const state = {
  allProducts: undefined,
}

const mutations = {
  SET_ALL: (state, productList) => {
    state.allProducts = productList
  },
}

const actions = {
  setProduct({ commit }, productList) {
    commit('SET_ALL', productList)
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
